import { Component, ElementRef, EventEmitter, Input, OnChanges, Output, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { NzNoAnimationDirective } from 'ng-zorro-antd/core/no-animation';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzTagModule } from 'ng-zorro-antd/tag';

@Component({
  selector: 'twaice-fe-message-tags',
  imports: [FormsModule, NzIconModule, NzInputModule, NzTagModule, NzNoAnimationDirective],
  template: `
    @for (tag of clonedTags; track tag) {
    <nz-tag [nzMode]="'closeable'" (nzOnClose)="deleteTag(tag)">
      {{ sliceTagName(tag) }}
    </nz-tag>
    } @if (!inputVisible) {
    <nz-tag class="editable-tag" nzNoAnimation (click)="showInput()">
      <nz-icon nzType="plus" />
      New Tag
    </nz-tag>
    } @else {
    <input
      #inputElement
      nz-input
      nzSize="small"
      type="text"
      [(ngModel)]="inputValue"
      style="width: 80px;"
      (blur)="createTag()"
      (keydown.enter)="createTag()"
    />
    }
  `,
  styles: [
    `
      .editable-tag {
        background: rgb(255, 255, 255);
        border-style: dashed;
      }
    `,
  ],
})
export class NzDemoTagControlComponent implements OnChanges {
  @Input() tags: string[];
  @Output() tagsChanged = new EventEmitter<string[]>();
  @ViewChild('inputElement', { static: false }) inputElement?: ElementRef;

  inputVisible = false;
  inputValue = '';

  clonedTags: string[];

  constructor() {}

  ngOnChanges() {
    this.clonedTags = structuredClone(this.tags);
  }

  deleteTag(tag: string): void {
    let modifiedTags = structuredClone(this.clonedTags);
    modifiedTags = modifiedTags.filter((t) => t !== tag);
    this.updateTags(modifiedTags);
  }

  sliceTagName(tag: string): string {
    const isLongTag = tag.length > 20;
    return isLongTag ? `${tag.slice(0, 20)}...` : tag;
  }

  showInput(): void {
    this.inputVisible = true;
    setTimeout(() => {
      this.inputElement?.nativeElement.focus();
    }, 10);
  }

  createTag(): void {
    if (this.inputValue && this.clonedTags.indexOf(this.inputValue) === -1) {
      const modifiedTags = [...this.clonedTags, this.inputValue];
      this.updateTags(modifiedTags);
    }
    this.inputValue = '';
    this.inputVisible = false;
  }

  private updateTags(tags: string[]): void {
    this.tagsChanged.emit(tags);
  }
}
